import { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { firestore } from '../lib/firebase';
import Navbar from '../components/NavbarDashboard';
import NavbarMobile from '../components/NavbarDashboardMobile';
import styles from '../styles/Dashboard.module.css';
import { UserContext } from '../lib/context';
import toast from 'react-hot-toast';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function Shipping() {
  return (
    <>
      <Navbar />
      <Body />
    </>
  );
}

function Body() {
  const [isLoading, setIsLoading] = useState(false);
  const { user, userData } = useContext(UserContext);

  // State Loaded
  const [userLoaded, setUserLoaded] = useState(false);
  const [userDataLoaded, setUserDataLoaded] = useState(false);
  const [stateLoaded, setStateLoaded] = useState(false);

  // Loaded - User
  useEffect(() => {
    if (user) {
      setUserLoaded(true);
    }
  }, [user]);

  // Loaded - UserData
  useEffect(() => {
    if (userData) {
      setUserDataLoaded(true);
      setValue('addressLine1', userData?.address?.addressLine1);
      setValue('addressLine2', userData?.address?.addressLine2);
      setValue('postalCode', userData?.address?.postalCode);
      setValue('city', userData?.address?.city);
      setValue('province', userData?.address?.province);
      setValue('deliveryInstructions', userData?.address?.deliveryInstructions);
    }
  }, [userData]);

  useEffect(() => {
    if (userLoaded && userDataLoaded) {
      setStateLoaded(true);
    }
  }, [userLoaded]);

  useEffect(() => {
    if (userLoaded && userDataLoaded) {
      setStateLoaded(true);
    }
  }, [userDataLoaded]);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    setError,
    clearErrors,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({ mode: 'onBlur', reValidateMode: 'onChange' });

  const sendForm = async (data) => {
    console.log(data);
    setIsLoading(true);

    // Firebase Code
    try {
      const userSnapshot = await firestore
        .collection('users')
        .doc(user?.uid)
        .get();
      const userData = userSnapshot.data();

      let insertData = {
        address: {
          ...data,
        },
      };

      // If missing user, create it
      if (!userData) {
        // CREATE new user
        const ref = firestore.collection('users').doc(user?.uid);
        await ref.set(insertData);
      } else {
        // Update existing user
        await userSnapshot.ref.update(insertData);
        toast.success('Shipping details saved.');
      }
    } catch (e) {
      // send to backend
    }

    setIsLoading(false);
  };

  return (
    <div className={`${styles['dashboard-container']} red`}>
      <div className={`${styles['dashboard-container-max']} red`}>
        <div className={`${styles['profile-item-container']} red`}>
          <form onSubmit={handleSubmit(sendForm)}>
            {/* INPUT */}
            {/* INPUT */}
            {/* INPUT */}
            <div className={`${styles['w100']} red`}>
              <div className={`${styles['input-label']} red`}>
                {stateLoaded ? 'Address line 1' : <Skeleton />}
              </div>
              {stateLoaded ? (
                <input
                  className={`${styles['input-text']} red`}
                  autoComplete="off"
                  placeholder="123 Main St"
                  {...register('addressLine1', {
                    required: true,
                  })}
                />
              ) : (
                <Skeleton height={55} />
              )}

              {errors.addressLine1?.type === 'required' && (
                <div className={`${styles['input-error']} red`}>
                  Address required
                </div>
              )}
            </div>

            <div className={`${styles['input-space']} red`} />

            {/* INPUT */}
            {/* INPUT */}
            {/* INPUT */}
            <div className={`${styles['w100']} red`}>
              <div className={`${styles['input-label']} red`}>
                {stateLoaded ? 'Address line 2 (optional)' : <Skeleton />}
              </div>
              {stateLoaded ? (
                <input
                  className={`${styles['input-text']} red`}
                  autoComplete="off"
                  placeholder="Unit 123"
                  {...register('addressLine2')}
                />
              ) : (
                <Skeleton height={55} />
              )}
            </div>

            <div className={`${styles['input-space']} red`} />

            {/* INPUT */}
            {/* INPUT */}
            {/* INPUT */}
            <div className={`${styles['w100']} red`}>
              <div className={`${styles['input-label']} red`}>
                {stateLoaded ? 'Postal code' : <Skeleton />}
              </div>
              {stateLoaded ? (
                <input
                  className={`${styles['input-text']} red`}
                  autoComplete="off"
                  placeholder="A1A 1A1"
                  {...register('postalCode', {
                    required: true,
                  })}
                />
              ) : (
                <Skeleton height={55} />
              )}

              {errors.postalCode?.type === 'required' && (
                <div className={`${styles['input-error']} red`}>
                  Postal code required
                </div>
              )}
            </div>

            <div className={`${styles['input-space']} red`} />

            {/* INPUT */}
            {/* INPUT */}
            {/* INPUT */}
            <div className={`${styles['input-height-container']} red`}>
              <div className={`${styles['w50']} red`}>
                <div className={`${styles['input-label']} red`}>
                  {stateLoaded ? 'City' : <Skeleton />}
                </div>
                {stateLoaded ? (
                  <input
                    className={`${styles['input-text']} red`}
                    autoComplete="off"
                    placeholder="Toronto"
                    {...register('city', {
                      required: true,
                    })}
                  />
                ) : (
                  <Skeleton height={55} />
                )}

                {errors.city?.type === 'required' && (
                  <div className={`${styles['input-error']} red`}>
                    City required
                  </div>
                )}
              </div>
              <div className={`${styles['input-space-flex']} red`} />
              <div className={`${styles['w50']} red`}>
                <div className={`${styles['input-label']} red`}>
                  {stateLoaded ? 'Province' : <Skeleton />}
                </div>
                {stateLoaded ? (
                  <input
                    className={`${styles['input-text']} red`}
                    autoComplete="off"
                    placeholder="ON"
                    {...register('province', {
                      required: true,
                    })}
                  />
                ) : (
                  <Skeleton height={55} />
                )}

                {errors.province?.type === 'required' && (
                  <div className={`${styles['input-error']} red`}>
                    Province required
                  </div>
                )}
              </div>
            </div>

            <div className={`${styles['input-space']} red`} />

            {/* INPUT */}
            {/* INPUT */}
            {/* INPUT */}
            <div className={`${styles['w100']} red`}>
              <div className={`${styles['input-label']} red`}>
                {stateLoaded ? (
                  'Delivery instructions (optional)'
                ) : (
                  <Skeleton />
                )}
              </div>
              {stateLoaded ? (
                <textarea
                  className={`${styles['input-textarea-small-shipping']} red`}
                  autoComplete="off"
                  {...register('deliveryInstructions')}
                />
              ) : (
                <Skeleton height={55} />
              )}
            </div>
            <button
              className={`${styles['save-changes-btn']} red`}
              type="submit"
              disabled={isLoading}
            >
              Save changes
            </button>
          </form>
        </div>
        <NavbarMobile />
      </div>
    </div>
  );
}
